var timeoutTracker = null

const handleNotification = (state, notification) => {
  state.notification = notification
  if (timeoutTracker != null) { clearTimeout(timeoutTracker) }
  timeoutTracker = setTimeout(() => {
    state.notification = null
  }, notification.timeout ? notification.timeout : 3000)
}

export default {

  state: {
    notification: null,
    news: null,
    sidebarOpen: window.innerWidth >= 992
  },

  mutations: {

    setNews (state, news) {
      state.news = news
    },

    toggleSidebar (state) {
      state.sidebarOpen = !state.sidebarOpen
    },

    setSidebarOpen (state, value) {
      state.sidebarOpen = value
    },

    setNotification (state, notification) {
      if (notification == null) {
        state.notification = null
        return
      }
      if (notification.type == null || ['info', 'danger', 'success'].indexOf(notification.type) === -1) {
        notification.type = 'info'
      }
      handleNotification(state, notification)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shared.js